<style lang="less">
.treenodebox {
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  z-index: 1000;
  box-sizing: border-box;
}
.mask {
  position: absolute;
  width: 100%;
  left: 0;
  bottom: 0;
  top: 0;
  background-color: rgba(30, 32, 38, 0.3);
}
.treenodes {
  position: relative;
  background: #f4f5f7;
  width: 100%;
  display: flex;
  border-top: 4px solid #f4f5f7;
  z-index: 5;

  > div {
    flex: 1;
  }
  .right {
    background-color: #fff;
  }

  li {
    height: 49px;
    padding-left: 30px;
    box-sizing: border-box;
    font-size: 14px;
    color: #1e2026;
    display: flex;
    align-items: center;
  }

  .active {
    background: #ffffff;
    border-left: 2px solid #2284f6;
  }
}
</style>
<template>
  <div class="treenodebox" ref="treenodes" v-show="showView" @touchmove="touchmove" @click.self="hide">
    <div class="mask" ref="mask" @click.self="hide"></div>

    <div class="treenodes">
      <div class="left">
        <ul>
          <li
            v-for="(item, i) in trees"
            :key="i"
            :class="{active: item.check}"
            @click="selGroup(item)"
          >{{ item.label }}</li>
        </ul>
      </div>
      <div class="right" v-show="child.length > 0">
        <ul>
          <li
            v-for="(item, i) in child"
            :key="i"
            :class="{active: item.check}"
            @click="selRow(item)"
          >{{ item.label }}</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      trees: [],
      child: [],
      showView: false,

      group: null,
    };
  },
  methods: {
    selGroup(row) {
      this.unSelAll();
      this.group = row;
      row.check = true;
      if (row.check && row.child) {
        this.child = row.child;
      } else {
        this.selRow(row);
      }
    },
    selRow(row) {
      console.log(row);
      console.log(this.group)
      this.$emit("onSel", this.group);
      this.hide();
    },

    unSelAll() {
      this.trees.forEach((row) => {
        row.check = false;
      });
    },

    show(data) {
      this.trees = data;
      this.child = [];
      var mask = this.$refs.mask;
      var treenodes = this.$refs.treenodes;
      var parent = treenodes.parentNode;
      var bcr = parent.getBoundingClientRect();
      treenodes.style.paddingTop = bcr.top + "px";
      mask.style.top = bcr.top + "px";
      this.showView = true;
    },
    hide() {
      this.showView = false;
    },

    touchmove(e){
      e.stopPropagation();
      e.preventDefault();
      e.stopImmediatePropagation();
    }
  },
};
</script>